import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {useLogHydrationFailed} from '../../../shared-deprecated/useLogHydrationFailed';
import {NAVIGATION_HEIGHT} from '../constants';
import {useNavigationBarSection} from '../hooks/useGetHeaderBulkSection';
import type {TopCategoryNavigationViewProps} from './TopCategoryNavigationView';
import {TopCategoryNavigationView} from './TopCategoryNavigationView';

export const TopCategoryNavigation: React.FC<
  TopCategoryNavigationViewProps
> = props => (
  <DataFetcher
    request={useNavigationBarSection()}
    Loading={Skeleton}
    View={TopCategoryNavigationView}
    viewProps={props}
    Error={() => null}
  />
);

const Skeleton: React.FC = () => {
  useLogHydrationFailed({context: 'TopCategoryNavigation'});
  return (
    <SkeletonBlock
      $height={`${NAVIGATION_HEIGHT}px`}
      data-ssr-skeleton="TopCategoryNavigation"
    />
  );
};
